import { css } from '@emotion/css';

export const shimmerEffect = css`
  height: 100%;
  width: 100%;
  border-radius: 1.6rem;
  background: linear-gradient(-45deg, #f2f2f2 40%, #fafafa 50%, #f2f2f2 60%);
  background-size: 300%;
  background-position-x: 100%;
  animation: shimmer 1s infinite linear;

  @keyframes shimmer {
    to {
      background-position-x: 0%;
    }
  }
`;
